'use client';

// AIS Karaoke Footer - Adjusted to match design
import Link from 'next/link';
import { useTranslations } from 'next-intl';

const logo = '/assets/ais-karaoke-logo.png';
const imgNimbusTelephone = '/assets/ic-tel.svg';

export default function Footer() {
  const t = useTranslations();

  return (
    <footer className="relative bg-black px-4 py-8 text-white sm:px-8 md:px-20 lg:px-[200px]">
      {/* Top border */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 top-0 border-t border-solid border-[#5e5e5e]"
      />

      {/* Main content container */}
      <div className="mx-auto flex max-w-screen-2xl flex-col gap-8 md:gap-16 xl:flex-row">
        {/* Left: Logo + Social Media */}
        <div className="flex w-full flex-col items-start gap-6">
          {/* Logo */}
          <Link href="/">
            <div
              className="h-[60px] w-[150px] bg-cover bg-center bg-no-repeat md:h-[100px] md:w-[271px]"
              style={{ backgroundImage: `url('${logo}')` }}
            />
          </Link>
        </div>
        {/* Center: Navigation Links (2 columns) */}
        <div className="flex w-full flex-col gap-8 md:flex-row md:gap-16 md:pl-20">
          <div className="mr-10 flex flex-col gap-4">
            <Link href="/" className="text-2xl font-medium hover:opacity-80">
              {t('HeaderNav.home')}
            </Link>
            <Link href="/karaoke" className="text-2xl font-medium hover:opacity-80">
              {t('HeaderNav.karaoke')}
            </Link>
            <Link href="/playlist" className="text-2xl font-medium hover:opacity-80">
              {t('HeaderNav.playlist')}
            </Link>
            <Link
              href="https://www.ais.th/consumers/entertainment/music/karaoke/#package-platinum"
              className="text-2xl font-medium hover:opacity-80"
            >
              {t('HeaderNav.package')}
            </Link>
          </div>
          <div className="mr-10 flex flex-col gap-4">
            <Link href="/term" className="text-2xl font-medium hover:opacity-80">
              {t('AccountSidebar.terms')}
            </Link>
            <Link href="/policy" className="text-2xl font-medium hover:opacity-80">
              {t('AccountSidebar.policy')}
            </Link>
          </div>

          <div className="flex gap-2.5">
            <div className="flex size-8 items-center justify-center rounded-full border border-ais-green">
              <img
                alt="phone"
                src={imgNimbusTelephone}
                className="size-6 rotate-180 scale-y-[-1]"
              />
            </div>
            <span className="text-xl font-bold md:text-2xl">1175</span>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="mt-8 text-center text-xs text-[#5e5e5e] md:text-sm">
        {t('copyright')}
      </div>
    </footer>
  );
}
